import type { FormEvent } from "react";
import type { AdminUser, AssignForm } from "./types.ts";

export function AssignLeadForm({
  form,
  sellers,
  submitting,
  onChange,
  onSubmit,
}: {
  form: AssignForm;
  sellers: AdminUser[];
  submitting: boolean;
  onChange: (form: AssignForm) => void;
  onSubmit: (event: FormEvent<HTMLFormElement>) => void;
}) {
  return (
    <section className="admin-section">
      <div className="admin-section-head">
        <h2>Atribuir lead</h2>
      </div>
      <form className="admin-form" onSubmit={onSubmit}>
        <label>
          <span>Vendedor</span>
          <select
            className="field"
            value={form.seller_email}
            onChange={(event) => onChange({ ...form, seller_email: event.currentTarget.value })}
          >
            {sellers.map((user) => <option key={user.id} value={user.email}>{user.email}</option>)}
          </select>
        </label>
        <label>
          <span>Nome do lead</span>
          <input className="field" value={form.name} onChange={(event) => onChange({ ...form, name: event.currentTarget.value })} />
        </label>
        <label>
          <span>Telefone</span>
          <input className="field" value={form.phone} onChange={(event) => onChange({ ...form, phone: event.currentTarget.value })} />
        </label>
        <label>
          <span>Curso</span>
          <input className="field" value={form.course} onChange={(event) => onChange({ ...form, course: event.currentTarget.value })} />
        </label>
        <label>
          <span>Prioridade</span>
          <select className="field" value={form.priority} onChange={(event) => onChange({ ...form, priority: event.currentTarget.value as AssignForm["priority"] })}>
            <option value="Media">Média</option>
            <option value="Alta">Alta</option>
            <option value="Baixa">Baixa</option>
          </select>
        </label>
        <button className="btn btn-primary" type="submit" disabled={submitting || !sellers.length}>
          {submitting ? "Atribuindo..." : "Atribuir lead"}
        </button>
      </form>
    </section>
  );
}
